import { Directive, Input, TemplateRef, inject } from '@angular/core';

/**
 * Common table cell by group
 */
@Directive({
  selector: '[mbsTableFilter]'
})
export class TableFilterDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  @Input('mbsTableFilter') public mode: 'item' | 'label' | 'divider' | '' = 'item';
}
